var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
        (_vm.isValid == false)? 'is-invalid':'',
        (_vm.isValid == true)? 'is-valid':''
    ]},[_c('div',{staticClass:"field form-control",class:[
            (_vm.isValid == false)? 'is-invalid':'',
            (_vm.isValid == true)? 'is-valid':''
        ],attrs:{"id":_vm.element_type,"disabled":_vm.disabled}}),_c('div',{staticClass:"invalid-feedback",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.errors))])])}
var staticRenderFns = []

export { render, staticRenderFns }